// AUTO-GENERATED by scripts/build-images.mjs — do not edit by hand.
// Run `npm run images` to regenerate after adding new photos.

import acousticTracking640Avif from '../Assets/optimized/acoustic-tracking-640.avif';
import acousticTracking640Webp from '../Assets/optimized/acoustic-tracking-640.webp';
import acousticTracking640Jpg  from '../Assets/optimized/acoustic-tracking-640.jpg';
import acousticTracking1024Avif from '../Assets/optimized/acoustic-tracking-1024.avif';
import acousticTracking1024Webp from '../Assets/optimized/acoustic-tracking-1024.webp';
import acousticTracking1024Jpg  from '../Assets/optimized/acoustic-tracking-1024.jpg';
import acousticTracking1600Avif from '../Assets/optimized/acoustic-tracking-1600.avif';
import acousticTracking1600Webp from '../Assets/optimized/acoustic-tracking-1600.webp';
import acousticTracking1600Jpg  from '../Assets/optimized/acoustic-tracking-1600.jpg';
import acousticTracking2400Avif from '../Assets/optimized/acoustic-tracking-2400.avif';
import acousticTracking2400Webp from '../Assets/optimized/acoustic-tracking-2400.webp';
import acousticTracking2400Jpg  from '../Assets/optimized/acoustic-tracking-2400.jpg';
import beachSunset1640Avif from '../Assets/optimized/beach-sunset1-640.avif';
import beachSunset1640Webp from '../Assets/optimized/beach-sunset1-640.webp';
import beachSunset1640Jpg  from '../Assets/optimized/beach-sunset1-640.jpg';
import coastalCity1640Avif from '../Assets/optimized/coastal-city1-640.avif';
import coastalCity1640Webp from '../Assets/optimized/coastal-city1-640.webp';
import coastalCity1640Jpg  from '../Assets/optimized/coastal-city1-640.jpg';
import coloradoFlyerTake4640Avif from '../Assets/optimized/colorado-flyer-take-4-640.avif';
import coloradoFlyerTake4640Webp from '../Assets/optimized/colorado-flyer-take-4-640.webp';
import coloradoFlyerTake4640Jpg  from '../Assets/optimized/colorado-flyer-take-4-640.jpg';
import coloradoFlyerTake41024Avif from '../Assets/optimized/colorado-flyer-take-4-1024.avif';
import coloradoFlyerTake41024Webp from '../Assets/optimized/colorado-flyer-take-4-1024.webp';
import coloradoFlyerTake41024Jpg  from '../Assets/optimized/colorado-flyer-take-4-1024.jpg';
import cornfieldLookingAtCamera640Avif from '../Assets/optimized/cornfield-looking-at-camera-640.avif';
import cornfieldLookingAtCamera640Webp from '../Assets/optimized/cornfield-looking-at-camera-640.webp';
import cornfieldLookingAtCamera640Jpg  from '../Assets/optimized/cornfield-looking-at-camera-640.jpg';
import cornfieldLookingAtCamera1024Avif from '../Assets/optimized/cornfield-looking-at-camera-1024.avif';
import cornfieldLookingAtCamera1024Webp from '../Assets/optimized/cornfield-looking-at-camera-1024.webp';
import cornfieldLookingAtCamera1024Jpg  from '../Assets/optimized/cornfield-looking-at-camera-1024.jpg';
import cornfieldLookingAtCamera1600Avif from '../Assets/optimized/cornfield-looking-at-camera-1600.avif';
import cornfieldLookingAtCamera1600Webp from '../Assets/optimized/cornfield-looking-at-camera-1600.webp';
import cornfieldLookingAtCamera1600Jpg  from '../Assets/optimized/cornfield-looking-at-camera-1600.jpg';
import cornfieldLookingAtCamera2400Avif from '../Assets/optimized/cornfield-looking-at-camera-2400.avif';
import cornfieldLookingAtCamera2400Webp from '../Assets/optimized/cornfield-looking-at-camera-2400.webp';
import cornfieldLookingAtCamera2400Jpg  from '../Assets/optimized/cornfield-looking-at-camera-2400.jpg';
import eddieBennettGarcias640Avif from '../Assets/optimized/eddie-bennett-garcias-640.avif';
import eddieBennettGarcias640Webp from '../Assets/optimized/eddie-bennett-garcias-640.webp';
import eddieBennettGarcias640Jpg  from '../Assets/optimized/eddie-bennett-garcias-640.jpg';
import eddieBennettGarcias1024Avif from '../Assets/optimized/eddie-bennett-garcias-1024.avif';
import eddieBennettGarcias1024Webp from '../Assets/optimized/eddie-bennett-garcias-1024.webp';
import eddieBennettGarcias1024Jpg  from '../Assets/optimized/eddie-bennett-garcias-1024.jpg';
import eddieBennettGarcias1600Avif from '../Assets/optimized/eddie-bennett-garcias-1600.avif';
import eddieBennettGarcias1600Webp from '../Assets/optimized/eddie-bennett-garcias-1600.webp';
import eddieBennettGarcias1600Jpg  from '../Assets/optimized/eddie-bennett-garcias-1600.jpg';
import garciasCrowd640Avif from '../Assets/optimized/garcias-crowd-640.avif';
import garciasCrowd640Webp from '../Assets/optimized/garcias-crowd-640.webp';
import garciasCrowd640Jpg  from '../Assets/optimized/garcias-crowd-640.jpg';
import garciasCrowd1024Avif from '../Assets/optimized/garcias-crowd-1024.avif';
import garciasCrowd1024Webp from '../Assets/optimized/garcias-crowd-1024.webp';
import garciasCrowd1024Jpg  from '../Assets/optimized/garcias-crowd-1024.jpg';
import garciasCrowd1600Avif from '../Assets/optimized/garcias-crowd-1600.avif';
import garciasCrowd1600Webp from '../Assets/optimized/garcias-crowd-1600.webp';
import garciasCrowd1600Jpg  from '../Assets/optimized/garcias-crowd-1600.jpg';
import garciasEddieYell640Avif from '../Assets/optimized/garcias-eddie-yell-640.avif';
import garciasEddieYell640Webp from '../Assets/optimized/garcias-eddie-yell-640.webp';
import garciasEddieYell640Jpg  from '../Assets/optimized/garcias-eddie-yell-640.jpg';
import garciasEddieYell1024Avif from '../Assets/optimized/garcias-eddie-yell-1024.avif';
import garciasEddieYell1024Webp from '../Assets/optimized/garcias-eddie-yell-1024.webp';
import garciasEddieYell1024Jpg  from '../Assets/optimized/garcias-eddie-yell-1024.jpg';
import garciasEddieYell1600Avif from '../Assets/optimized/garcias-eddie-yell-1600.avif';
import garciasEddieYell1600Webp from '../Assets/optimized/garcias-eddie-yell-1600.webp';
import garciasEddieYell1600Jpg  from '../Assets/optimized/garcias-eddie-yell-1600.jpg';
import garciasLive640Avif from '../Assets/optimized/garcias-live-640.avif';
import garciasLive640Webp from '../Assets/optimized/garcias-live-640.webp';
import garciasLive640Jpg  from '../Assets/optimized/garcias-live-640.jpg';
import garciasLive1024Avif from '../Assets/optimized/garcias-live-1024.avif';
import garciasLive1024Webp from '../Assets/optimized/garcias-live-1024.webp';
import garciasLive1024Jpg  from '../Assets/optimized/garcias-live-1024.jpg';
import garciasLive1600Avif from '../Assets/optimized/garcias-live-1600.avif';
import garciasLive1600Webp from '../Assets/optimized/garcias-live-1600.webp';
import garciasLive1600Jpg  from '../Assets/optimized/garcias-live-1600.jpg';
import garciasSwirl640Avif from '../Assets/optimized/garcias-swirl-640.avif';
import garciasSwirl640Webp from '../Assets/optimized/garcias-swirl-640.webp';
import garciasSwirl640Jpg  from '../Assets/optimized/garcias-swirl-640.jpg';
import garciasSwirl1024Avif from '../Assets/optimized/garcias-swirl-1024.avif';
import garciasSwirl1024Webp from '../Assets/optimized/garcias-swirl-1024.webp';
import garciasSwirl1024Jpg  from '../Assets/optimized/garcias-swirl-1024.jpg';
import garciasSwirl1600Avif from '../Assets/optimized/garcias-swirl-1600.avif';
import garciasSwirl1600Webp from '../Assets/optimized/garcias-swirl-1600.webp';
import garciasSwirl1600Jpg  from '../Assets/optimized/garcias-swirl-1600.jpg';
import greenroomSwirl640Avif from '../Assets/optimized/greenroom-swirl-640.avif';
import greenroomSwirl640Webp from '../Assets/optimized/greenroom-swirl-640.webp';
import greenroomSwirl640Jpg  from '../Assets/optimized/greenroom-swirl-640.jpg';
import greenroomSwirl1024Avif from '../Assets/optimized/greenroom-swirl-1024.avif';
import greenroomSwirl1024Webp from '../Assets/optimized/greenroom-swirl-1024.webp';
import greenroomSwirl1024Jpg  from '../Assets/optimized/greenroom-swirl-1024.jpg';
import greenroomSwirl1600Avif from '../Assets/optimized/greenroom-swirl-1600.avif';
import greenroomSwirl1600Webp from '../Assets/optimized/greenroom-swirl-1600.webp';
import greenroomSwirl1600Jpg  from '../Assets/optimized/greenroom-swirl-1600.jpg';
import joytripSunrisePhoto640Avif from '../Assets/optimized/joytrip-sunrise-photo-640.avif';
import joytripSunrisePhoto640Webp from '../Assets/optimized/joytrip-sunrise-photo-640.webp';
import joytripSunrisePhoto640Jpg  from '../Assets/optimized/joytrip-sunrise-photo-640.jpg';
import joytripSunrisePhoto1024Avif from '../Assets/optimized/joytrip-sunrise-photo-1024.avif';
import joytripSunrisePhoto1024Webp from '../Assets/optimized/joytrip-sunrise-photo-1024.webp';
import joytripSunrisePhoto1024Jpg  from '../Assets/optimized/joytrip-sunrise-photo-1024.jpg';
import joytripSunrisePhoto1600Avif from '../Assets/optimized/joytrip-sunrise-photo-1600.avif';
import joytripSunrisePhoto1600Webp from '../Assets/optimized/joytrip-sunrise-photo-1600.webp';
import joytripSunrisePhoto1600Jpg  from '../Assets/optimized/joytrip-sunrise-photo-1600.jpg';
import joytripSunrisePhoto2400Avif from '../Assets/optimized/joytrip-sunrise-photo-2400.avif';
import joytripSunrisePhoto2400Webp from '../Assets/optimized/joytrip-sunrise-photo-2400.webp';
import joytripSunrisePhoto2400Jpg  from '../Assets/optimized/joytrip-sunrise-photo-2400.jpg';
import joytripSunsetPhoto640Avif from '../Assets/optimized/joytrip-sunset-photo-640.avif';
import joytripSunsetPhoto640Webp from '../Assets/optimized/joytrip-sunset-photo-640.webp';
import joytripSunsetPhoto640Jpg  from '../Assets/optimized/joytrip-sunset-photo-640.jpg';
import joytripSunsetPhoto1024Avif from '../Assets/optimized/joytrip-sunset-photo-1024.avif';
import joytripSunsetPhoto1024Webp from '../Assets/optimized/joytrip-sunset-photo-1024.webp';
import joytripSunsetPhoto1024Jpg  from '../Assets/optimized/joytrip-sunset-photo-1024.jpg';
import joytripSunsetPhoto1600Avif from '../Assets/optimized/joytrip-sunset-photo-1600.avif';
import joytripSunsetPhoto1600Webp from '../Assets/optimized/joytrip-sunset-photo-1600.webp';
import joytripSunsetPhoto1600Jpg  from '../Assets/optimized/joytrip-sunset-photo-1600.jpg';
import joytripSunsetPhoto2400Avif from '../Assets/optimized/joytrip-sunset-photo-2400.avif';
import joytripSunsetPhoto2400Webp from '../Assets/optimized/joytrip-sunset-photo-2400.webp';
import joytripSunsetPhoto2400Jpg  from '../Assets/optimized/joytrip-sunset-photo-2400.jpg';
import lauderdaleSunriseCorn640Avif from '../Assets/optimized/lauderdale-sunrise-corn-640.avif';
import lauderdaleSunriseCorn640Webp from '../Assets/optimized/lauderdale-sunrise-corn-640.webp';
import lauderdaleSunriseCorn640Jpg  from '../Assets/optimized/lauderdale-sunrise-corn-640.jpg';
import lauderdaleSunriseCorn1024Avif from '../Assets/optimized/lauderdale-sunrise-corn-1024.avif';
import lauderdaleSunriseCorn1024Webp from '../Assets/optimized/lauderdale-sunrise-corn-1024.webp';
import lauderdaleSunriseCorn1024Jpg  from '../Assets/optimized/lauderdale-sunrise-corn-1024.jpg';
import lauderdaleSunriseCorn1600Avif from '../Assets/optimized/lauderdale-sunrise-corn-1600.avif';
import lauderdaleSunriseCorn1600Webp from '../Assets/optimized/lauderdale-sunrise-corn-1600.webp';
import lauderdaleSunriseCorn1600Jpg  from '../Assets/optimized/lauderdale-sunrise-corn-1600.jpg';
import lauderdaleSunriseCorn2400Avif from '../Assets/optimized/lauderdale-sunrise-corn-2400.avif';
import lauderdaleSunriseCorn2400Webp from '../Assets/optimized/lauderdale-sunrise-corn-2400.webp';
import lauderdaleSunriseCorn2400Jpg  from '../Assets/optimized/lauderdale-sunrise-corn-2400.jpg';
import liveLittleBear640Avif from '../Assets/optimized/live-little-bear-640.avif';
import liveLittleBear640Webp from '../Assets/optimized/live-little-bear-640.webp';
import liveLittleBear640Jpg  from '../Assets/optimized/live-little-bear-640.jpg';
import liveLittleBear1024Avif from '../Assets/optimized/live-little-bear-1024.avif';
import liveLittleBear1024Webp from '../Assets/optimized/live-little-bear-1024.webp';
import liveLittleBear1024Jpg  from '../Assets/optimized/live-little-bear-1024.jpg';
import liveLittleBear1600Avif from '../Assets/optimized/live-little-bear-1600.avif';
import liveLittleBear1600Webp from '../Assets/optimized/live-little-bear-1600.webp';
import liveLittleBear1600Jpg  from '../Assets/optimized/live-little-bear-1600.jpg';
import liveLittleBear2400Avif from '../Assets/optimized/live-little-bear-2400.avif';
import liveLittleBear2400Webp from '../Assets/optimized/live-little-bear-2400.webp';
import liveLittleBear2400Jpg  from '../Assets/optimized/live-little-bear-2400.jpg';
import skylarkLive640Avif from '../Assets/optimized/skylark-live-640.avif';
import skylarkLive640Webp from '../Assets/optimized/skylark-live-640.webp';
import skylarkLive640Jpg  from '../Assets/optimized/skylark-live-640.jpg';
import skylarkLive1024Avif from '../Assets/optimized/skylark-live-1024.avif';
import skylarkLive1024Webp from '../Assets/optimized/skylark-live-1024.webp';
import skylarkLive1024Jpg  from '../Assets/optimized/skylark-live-1024.jpg';
import skylarkLive1600Avif from '../Assets/optimized/skylark-live-1600.avif';
import skylarkLive1600Webp from '../Assets/optimized/skylark-live-1600.webp';
import skylarkLive1600Jpg  from '../Assets/optimized/skylark-live-1600.jpg';
import studioTrio640Avif from '../Assets/optimized/studio-trio-640.avif';
import studioTrio640Webp from '../Assets/optimized/studio-trio-640.webp';
import studioTrio640Jpg  from '../Assets/optimized/studio-trio-640.jpg';
import studioTrio1024Avif from '../Assets/optimized/studio-trio-1024.avif';
import studioTrio1024Webp from '../Assets/optimized/studio-trio-1024.webp';
import studioTrio1024Jpg  from '../Assets/optimized/studio-trio-1024.jpg';
import studioTrio1600Avif from '../Assets/optimized/studio-trio-1600.avif';
import studioTrio1600Webp from '../Assets/optimized/studio-trio-1600.webp';
import studioTrio1600Jpg  from '../Assets/optimized/studio-trio-1600.jpg';
import vueFullBand640Avif from '../Assets/optimized/vue-full-band-640.avif';
import vueFullBand640Webp from '../Assets/optimized/vue-full-band-640.webp';
import vueFullBand640Jpg  from '../Assets/optimized/vue-full-band-640.jpg';
import vueFullBand1024Avif from '../Assets/optimized/vue-full-band-1024.avif';
import vueFullBand1024Webp from '../Assets/optimized/vue-full-band-1024.webp';
import vueFullBand1024Jpg  from '../Assets/optimized/vue-full-band-1024.jpg';
import vueFullBand1600Avif from '../Assets/optimized/vue-full-band-1600.avif';
import vueFullBand1600Webp from '../Assets/optimized/vue-full-band-1600.webp';
import vueFullBand1600Jpg  from '../Assets/optimized/vue-full-band-1600.jpg';
import vueFullBand2400Avif from '../Assets/optimized/vue-full-band-2400.avif';
import vueFullBand2400Webp from '../Assets/optimized/vue-full-band-2400.webp';
import vueFullBand2400Jpg  from '../Assets/optimized/vue-full-band-2400.jpg';

export const imageManifest = Object.freeze({
  'acoustic-tracking': {
    avif: [acousticTracking640Avif, acousticTracking1024Avif, acousticTracking1600Avif, acousticTracking2400Avif],
    webp: [acousticTracking640Webp, acousticTracking1024Webp, acousticTracking1600Webp, acousticTracking2400Webp],
    jpg:  [acousticTracking640Jpg, acousticTracking1024Jpg, acousticTracking1600Jpg, acousticTracking2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 4284,
    naturalHeight: 5712,
  },
  'beach-sunset1': {
    avif: [beachSunset1640Avif],
    webp: [beachSunset1640Webp],
    jpg:  [beachSunset1640Jpg],
    widths: [640],
    naturalWidth: 640,
    naturalHeight: 427,
  },
  'coastal-city1': {
    avif: [coastalCity1640Avif],
    webp: [coastalCity1640Webp],
    jpg:  [coastalCity1640Jpg],
    widths: [640],
    naturalWidth: 940,
    naturalHeight: 625,
  },
  'colorado-flyer-take-4': {
    avif: [coloradoFlyerTake4640Avif, coloradoFlyerTake41024Avif],
    webp: [coloradoFlyerTake4640Webp, coloradoFlyerTake41024Webp],
    jpg:  [coloradoFlyerTake4640Jpg, coloradoFlyerTake41024Jpg],
    widths: [640, 1024],
    naturalWidth: 1545,
    naturalHeight: 2000,
  },
  'cornfield-looking-at-camera': {
    avif: [cornfieldLookingAtCamera640Avif, cornfieldLookingAtCamera1024Avif, cornfieldLookingAtCamera1600Avif, cornfieldLookingAtCamera2400Avif],
    webp: [cornfieldLookingAtCamera640Webp, cornfieldLookingAtCamera1024Webp, cornfieldLookingAtCamera1600Webp, cornfieldLookingAtCamera2400Webp],
    jpg:  [cornfieldLookingAtCamera640Jpg, cornfieldLookingAtCamera1024Jpg, cornfieldLookingAtCamera1600Jpg, cornfieldLookingAtCamera2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 4240,
    naturalHeight: 2832,
  },
  'eddie-bennett-garcias': {
    avif: [eddieBennettGarcias640Avif, eddieBennettGarcias1024Avif, eddieBennettGarcias1600Avif],
    webp: [eddieBennettGarcias640Webp, eddieBennettGarcias1024Webp, eddieBennettGarcias1600Webp],
    jpg:  [eddieBennettGarcias640Jpg, eddieBennettGarcias1024Jpg, eddieBennettGarcias1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'garcias-crowd': {
    avif: [garciasCrowd640Avif, garciasCrowd1024Avif, garciasCrowd1600Avif],
    webp: [garciasCrowd640Webp, garciasCrowd1024Webp, garciasCrowd1600Webp],
    jpg:  [garciasCrowd640Jpg, garciasCrowd1024Jpg, garciasCrowd1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'garcias-eddie-yell': {
    avif: [garciasEddieYell640Avif, garciasEddieYell1024Avif, garciasEddieYell1600Avif],
    webp: [garciasEddieYell640Webp, garciasEddieYell1024Webp, garciasEddieYell1600Webp],
    jpg:  [garciasEddieYell640Jpg, garciasEddieYell1024Jpg, garciasEddieYell1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'garcias-live': {
    avif: [garciasLive640Avif, garciasLive1024Avif, garciasLive1600Avif],
    webp: [garciasLive640Webp, garciasLive1024Webp, garciasLive1600Webp],
    jpg:  [garciasLive640Jpg, garciasLive1024Jpg, garciasLive1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'garcias-swirl': {
    avif: [garciasSwirl640Avif, garciasSwirl1024Avif, garciasSwirl1600Avif],
    webp: [garciasSwirl640Webp, garciasSwirl1024Webp, garciasSwirl1600Webp],
    jpg:  [garciasSwirl640Jpg, garciasSwirl1024Jpg, garciasSwirl1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'greenroom-swirl': {
    avif: [greenroomSwirl640Avif, greenroomSwirl1024Avif, greenroomSwirl1600Avif],
    webp: [greenroomSwirl640Webp, greenroomSwirl1024Webp, greenroomSwirl1600Webp],
    jpg:  [greenroomSwirl640Jpg, greenroomSwirl1024Jpg, greenroomSwirl1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1365,
  },
  'joytrip-sunrise-photo': {
    avif: [joytripSunrisePhoto640Avif, joytripSunrisePhoto1024Avif, joytripSunrisePhoto1600Avif, joytripSunrisePhoto2400Avif],
    webp: [joytripSunrisePhoto640Webp, joytripSunrisePhoto1024Webp, joytripSunrisePhoto1600Webp, joytripSunrisePhoto2400Webp],
    jpg:  [joytripSunrisePhoto640Jpg, joytripSunrisePhoto1024Jpg, joytripSunrisePhoto1600Jpg, joytripSunrisePhoto2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 2629,
    naturalHeight: 1497,
  },
  'joytrip-sunset-photo': {
    avif: [joytripSunsetPhoto640Avif, joytripSunsetPhoto1024Avif, joytripSunsetPhoto1600Avif, joytripSunsetPhoto2400Avif],
    webp: [joytripSunsetPhoto640Webp, joytripSunsetPhoto1024Webp, joytripSunsetPhoto1600Webp, joytripSunsetPhoto2400Webp],
    jpg:  [joytripSunsetPhoto640Jpg, joytripSunsetPhoto1024Jpg, joytripSunsetPhoto1600Jpg, joytripSunsetPhoto2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 4240,
    naturalHeight: 2385,
  },
  'lauderdale-sunrise-corn': {
    avif: [lauderdaleSunriseCorn640Avif, lauderdaleSunriseCorn1024Avif, lauderdaleSunriseCorn1600Avif, lauderdaleSunriseCorn2400Avif],
    webp: [lauderdaleSunriseCorn640Webp, lauderdaleSunriseCorn1024Webp, lauderdaleSunriseCorn1600Webp, lauderdaleSunriseCorn2400Webp],
    jpg:  [lauderdaleSunriseCorn640Jpg, lauderdaleSunriseCorn1024Jpg, lauderdaleSunriseCorn1600Jpg, lauderdaleSunriseCorn2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 2843,
    naturalHeight: 1518,
  },
  'live-little-bear': {
    avif: [liveLittleBear640Avif, liveLittleBear1024Avif, liveLittleBear1600Avif, liveLittleBear2400Avif],
    webp: [liveLittleBear640Webp, liveLittleBear1024Webp, liveLittleBear1600Webp, liveLittleBear2400Webp],
    jpg:  [liveLittleBear640Jpg, liveLittleBear1024Jpg, liveLittleBear1600Jpg, liveLittleBear2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 5159,
    naturalHeight: 4000,
  },
  'skylark-live': {
    avif: [skylarkLive640Avif, skylarkLive1024Avif, skylarkLive1600Avif],
    webp: [skylarkLive640Webp, skylarkLive1024Webp, skylarkLive1600Webp],
    jpg:  [skylarkLive640Jpg, skylarkLive1024Jpg, skylarkLive1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2048,
    naturalHeight: 1536,
  },
  'studio-trio': {
    avif: [studioTrio640Avif, studioTrio1024Avif, studioTrio1600Avif],
    webp: [studioTrio640Webp, studioTrio1024Webp, studioTrio1600Webp],
    jpg:  [studioTrio640Jpg, studioTrio1024Jpg, studioTrio1600Jpg],
    widths: [640, 1024, 1600],
    naturalWidth: 2160,
    naturalHeight: 1620,
  },
  'vue-full-band': {
    avif: [vueFullBand640Avif, vueFullBand1024Avif, vueFullBand1600Avif, vueFullBand2400Avif],
    webp: [vueFullBand640Webp, vueFullBand1024Webp, vueFullBand1600Webp, vueFullBand2400Webp],
    jpg:  [vueFullBand640Jpg, vueFullBand1024Jpg, vueFullBand1600Jpg, vueFullBand2400Jpg],
    widths: [640, 1024, 1600, 2400],
    naturalWidth: 2810,
    naturalHeight: 2720,
  },
});
